import PropTypes from "prop-types";
import { useRef } from "react";
import "./Stepper.css";

export default function Stepper({
	label,
	id,
	value,
	min,
	max,
	step,
	onChange,
	disabled,
}) {
	const inputRef = useRef(null);

	const handleIncrement = () => {
		const newValue = Math.min(value + step, max);
		onChange(newValue);
	};

	const handleDecrement = () => {
		const newValue = Math.max(value - step, min);
		onChange(newValue);
	};

	// handle manual input
	const handleInputChange = (e) => {
		const newValue = Number(e.target.value);
		if (newValue >= min && newValue <= max) {
			onChange(newValue);
		}
	};

	const handleInputFocus = () => {
		// Select the input content on focus
		inputRef.current.select();
	};

	// -----------------------------------------------------------------------------

	return (
		<div className={disabled ? "stepper-disabled" : ""}>
			{/* Label */}
			<label htmlFor={id} className="stepper-label">
				{label}
			</label>

			{/* Stepper */}
			<div className="stepper" role="group" aria-label="Stepper">
				<button
					type="button"
					onClick={handleDecrement}
					disabled={value <= min}
					aria-label="Decrement"
				>
					−
				</button>

				<input
					ref={inputRef}
					onFocus={handleInputFocus}
					id={id}
					type="number"
					value={value}
					min={min}
					max={max}
					step={step}
					onChange={handleInputChange}
					disabled={disabled}
					aria-label="Current value"
					aria-valuemin={min}
					aria-valuemax={max}
					aria-valuenow={value}
				/>

				<button
					type="button"
					onClick={handleIncrement}
					disabled={value >= max}
					aria-label="Increment"
				>
					+
				</button>
			</div>
		</div>
	);
}

Stepper.propTypes = {
	label: PropTypes.string.isRequired,
	id: PropTypes.string.isRequired,
	value: PropTypes.number.isRequired,
	min: PropTypes.number.isRequired,
	max: PropTypes.number.isRequired,
	step: PropTypes.number.isRequired,
	onChange: PropTypes.func.isRequired,
	disabled: PropTypes.bool,
};
